<template>
  <div class="border border-dark-blue shadow rounded-md p-6 w-full mx-auto">
    <div class="flex space-x-4" :class="{ 'animate-pulse' : loading }">
      <div class="flex-1 space-y-4 py-1">
        <div class="h-4 bg-medium-blue rounded w-1/2"></div>
        <div class="h-8 bg-medium-blue rounded w-1/4"></div>
        <hr class="text-gray-300 my-4">
        <div class="space-y-2">
          <div class="h-4 bg-medium-blue rounded"></div>
          <div class="h-4 bg-medium-blue rounded w-1/5"></div>
        </div>
        <hr class="text-gray-300 my-4">
        <div class="mx-auto h-8 bg-medium-blue rounded w-1/2"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InvoiceLoadingCard",
  props: ['loading']
}
</script>

<style scoped>

</style>
